import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { URLSearchParams } from '@angular/http';
import { GenericHttpService } from '../generic-http.service';
import { PremioConsumidorModel } from './../model/premio-consumidor.model';
import { PremioAgrupadoModel } from './../model/premio-agrupado.model';
import { UnidadeFederacaoModel } from './../model/unidade-federacao.model';
import { ParametrosService } from './parametros.service';
import { PaginatedList } from './../paginated-list';
import { ConfiguracoesProjeto } from '../index';
import { ConsumidorService } from '../../restrito/consumidor/shared/consumidor.service';
import { LoadingService } from '../../shared-layout/loading/loading.service';
import { FiltroPremiacaoCidadao } from '../model/filtro-premiacao-cidadao';

@Injectable()
export class PremioSorteioService {

    public totalPremios = 0;
    public _urlBase: string;
    public _urlBaseBilhete: string;
    public _urlDocsNBP: string;
    public configuracao: ConfiguracoesProjeto;
    public _premiosSelecionadosParaResgate: PremioConsumidorModel[];
    public _ufs: UnidadeFederacaoModel;
    public premiosAgrupadosOnSearch: Subject<PremioAgrupadoModel[]> = new Subject<PremioAgrupadoModel[]>();
    public totalBilhetesOnSearch: Subject<number> = new Subject<number>();
    public premioSorteioChange = new Subject<PremioConsumidorModel[]>();


    constructor(private readonly genericHttpService: GenericHttpService<PremioConsumidorModel>,
                private readonly premioAgrupadoHttpService: GenericHttpService<PremioAgrupadoModel>,
                private readonly totalBilhetesHttpService: GenericHttpService<number>,
                private readonly parametrosService: ParametrosService,
                private readonly consumidorService: ConsumidorService,
                private readonly router: Router,
                private readonly ngbModalService: NgbModal,
                private readonly loadingService: LoadingService) { }

    public get urlBase() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBase = this.configuracao.uri  + 'premio/';
        return this._urlBase;
    }

    public get urlBasePremioSorteio() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBase = this.configuracao.uri  + 'premio-sorteio/';
        return this._urlBase;
    }

    public get urlBaseBilhete() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBaseBilhete = this.configuracao.uri  + 'bilhetes/';
        return this._urlBaseBilhete;
    }

    public get urlDocsNBP() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlDocsNBP = this.configuracao.uri_docsnbp;
        return this._urlDocsNBP;
    }

    getPremios(filtro: FiltroPremiacaoCidadao): void {
        this.loadingService.exibirLoading("Aguarde");

        const params: URLSearchParams = new URLSearchParams();
        params.append('consumidorId', filtro.consumidorId.toString());
        params.append('page', filtro.page.toString());
        params.append('pageSize', filtro.pageSize.toString());

        const s: Subscription = this.genericHttpService
          .get(this.urlBase + `premiacao-cidadao/paginado`, params)
            .subscribe(
                (data: PaginatedList<PremioConsumidorModel>) => {
                    this.totalPremios = data.totalCount;
                    this.premioSorteioChange.next(data.list.slice());
                },
                (error: any) => {
                    this.totalPremios = 0;
                    this.premioSorteioChange.next([]);
                    this.loadingService.esconderLoading();
                },
                () => {
                    s.unsubscribe();
                    this.loadingService.esconderLoading();
                }
            );
    }
          public obterPremiosAgrupados(seqSorteioPremiacaoConsumidor: number) {
            const params: URLSearchParams = new URLSearchParams();
            params.append('seqSorteioPremiacaoConsumidor', seqSorteioPremiacaoConsumidor.toString());
            const s: Subscription = this.premioAgrupadoHttpService.getAny(this.urlBasePremioSorteio.concat(`premios-agrupados`), params)
                .subscribe(
                    (data: PremioAgrupadoModel[]) => {
                        this.premiosAgrupadosOnSearch.next(data);
                    },
                    (erro: any) => {
                        this.premiosAgrupadosOnSearch.next([]);
                    },
                    () => {
                        s.unsubscribe();
                    }
                );
        }

   public getPremiosSorteio(sorteioId: number): void {
        const s: Subscription = this.genericHttpService.getAll(`${this.urlBase}/ObterPremiosSorteio/${sorteioId}`)
            .subscribe(
                (data: Array<PremioConsumidorModel>) => {
                    this.premioSorteioChange.next(data.slice());
                },
                (error: any) => {
                    this.premioSorteioChange.next([]);
                },
                () => {
                    s.unsubscribe();
                }

            );
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/premio-sorteio.service.ts